const defaultFirstName = 'Albert'
const defaultLastName = 'Shen'

const ADDRESS_TEMPLATES = [{
  'line1': "1640 Johnson Way Suite A",
  'line2': "",
  'city': "New Castle",
  'district': "",
  'state': "DE",
  'country': "US",
  'phone': "3237085070",
  'zipCode': "19720",
  'dutyWarning': false,
  'identityAuth': false,
}, {
  'line1': "6210 NE 92ND DR Suite 105",
  'line2': "BXL",
  'city': "Portland",
  'district': "",
  'state': "OR",
  'country': "US",
  'phone': "5038415224",
  'zipCode': "97220",
  'dutyWarning': false,
  'identityAuth': false,
}]

const CN_LAST_NAME_DICT = [
  "li", "wang", "zhang", "liu", "chen", "yang", "zhao", "huang", "zhou", "wu", "xu",
  "sun", "hu", "zhu", "gao", "lin", "he", "guo", "ma", "luo", "liang", "song", "zheng",
  "xie", "han", "tang", "feng", "yu", "dong", "xiao", "cheng", "cao", "yuan", "deng",
  "fu", "shen", "ceng", "peng", "lü", "su", "lu", "jiang", "cai", "jia", "ding", "wei",
  "xue", "ye", "yan", "pan", "du", "dai", "xia", "zhong", "tian", "ren", "fan", "fang",
  "shi", "yao", "tan", "liao", "zou", "xiong", "jin", "hao", "kong", "bai", "cui",
  "kang", "mao", "qiu", "qin", "gu", "hou", "shao", "meng", "long", "wan", "duan",
  "qian", "yin", "yi", "chang", "qiao", "lai", "gong", "wen", "pang", "lan", "tao",
  "hong", "zhai", "an", "ni", "niu", "ji", "ge", "you", "bi", "nie", "cong", "jiao",
  "xiang", "xing", "yue", "qi", "mei", "mo", "zhuang", "xin", "guan", "zuo", "tu",
  "shu", "geng", "mou", "bu", "zhan", "miao", "ling", "fei", "sheng", "tong", "ou",
  "zhen", "qu", "pei", "xi", "cha", "bao", "huo", "weng", "sui", "zhi", "gan", "jing",
  "dan", "si", "ning", "ke", "ruan", "gui", "min", "jie", "qiang", "chai", "hua", "che",
  "ran", "bian", "rao", "diao", "mi", "chi", "teng", "zang", "gou", "quan", "chu", "lian",
  "jian", "lou", "gai", "mu", "dang", "lang", "di", "luan", "shang", "dou", "ao", "leng",
  "zhuo", "chou", "ai", "le", "xian", "kuang", "zong", "ying", "tai", "ju", "seng", "sang",
  "ming", "sha", "cen", "murong"
]

const CN_REGULAR_NAME_DICT = [
  "a", "ba", "pa", "ma", "fa", "da", "ta", "na", "la", "ga", "ka", "ha", "zha", "cha", "sha",
  "za", "ca", "sa", "ai", "bai", "pai", "mai", "dai", "tai", "nai", "lai", "gai", "kai", "hai",
  "zhai", "chai", "shai", "zai", "cai", "sai", "an", "ban", "pan", "man", "fan", "dan", "tan",
  "nan", "lan", "gan", "kan", "han", "zhan", "chan", "shan", "ran", "zan", "can", "san", "ang",
  "bang", "pang", "mang", "fang", "dang", "tang", "nang", "lang", "gang", "kang", "hang", "zhang",
  "chang", "shang", "rang", "zang", "cang", "sang", "ao", "bao", "pao", "mao", "dao", "tao", "nao",
  "lao", "gao", "kao", "hao", "zhao", "chao", "shao", "rao", "zao", "cao", "sao", "e", "me", "de",
  "te", "ne", "le", "ge", "ke", "he", "zhe", "che", "she", "re", "ze", "ce", "se", "ei", "bei",
  "pei", "mei", "fei", "dei", "nei", "lei", "gei", "hei", "shei", "zei", "en", "ben", "pen", "men",
  "fen", "den", "nen", "gen", "ken", "hen", "zhen", "chen", "shen", "ren", "zen", "cen", "sen",
  "beng", "peng", "meng", "feng", "deng", "teng", "neng", "leng", "geng", "keng", "heng", "zheng",
  "cheng", "sheng", "reng", "zeng", "ceng", "seng", "er", "yi", "bi", "pi", "mi", "di", "ti", "ni",
  "li", "ji", "qi", "xi", "zhi", "chi", "shi", "ri", "zi", "ci", "si", "ya", "dia", "lia", "jia",
  "qia", "xia", "yan", "bian", "pian", "mian", "dian", "tian", "nian", "lian", "jian", "qian",
  "xian", "yang", "niang", "liang", "jiang", "qiang", "xiang", "yao", "biao", "piao", "miao", "diao",
  "tiao", "niao", "liao", "jiao", "qiao", "xiao", "ye", "bie", "pie", "mie", "die", "tie", "nie", "lie",
  "jie", "qie", "xie", "yin", "bin", "pin", "min", "nin", "lin", "jin", "qin", "xin", "ying", "bing",
  "ping", "ming", "ding", "ting", "ning", "ling", "jing", "qing", "xing", "yo", "yong", "jiong",
  "qiong", "xiong", "you", "miu", "diu", "niu", "liu", "jiu", "qiu", "xiu", "o", "bo", "po", "mo",
  "fo", "lo", "weng", "dong", "tong", "nong", "long", "gong", "kong", "hong", "zhong", "chong",
  "rong", "zong", "cong", "song", "ou", "pou", "mou", "fou", "dou", "tou", "nou", "lou", "gou",
  "kou", "hou", "zhou", "chou", "shou", "rou", "zou", "cou", "sou", "wu", "bu", "pu", "mu", "fu",
  "du", "tu", "nu", "lu", "gu", "ku", "hu", "zhu", "chu", "shu", "ru", "zu", "cu", "su", "wa",
  "gua", "kua", "hua", "zhua", "shua", "wai", "guai", "kuai", "huai", "chuai", "shuai", "wan",
  "duan", "tuan", "nuan", "luan", "guan", "kuan", "huan", "zhuan", "chuan", "shuan", "ruan",
  "zuan", "cuan", "suan", "wang", "guang", "kuang", "huang", "zhuang", "chuang", "shuang",
  "yue", "nüe", "lüe", "jue", "que", "xue", "wei", "dui", "tui", "gui", "kui", "hui", "zhui",
  "chui", "shui", "rui", "zui", "cui", "sui", "wen", "dun", "tun", "lun", "gun", "kun", "hun",
  "zhun", "chun", "shun", "run", "zun", "cun", "sun", "wo", "duo", "tuo", "nuo", "luo", "guo",
  "kuo", "huo", "zhuo", "chuo", "shuo", "ruo", "zuo", "cuo", "suo", "yu", "nü", "lü", "ju",
  "qu", "xu", "yuan", "juan", "quan", "xuan", "yun", "jun", "qun", "xun"
]

function natural(min: number, max: number) {
  return Math.round(Math.random() * (max - min)) + min
}

function pickLastName() {
  return CN_LAST_NAME_DICT[natural(0, CN_LAST_NAME_DICT.length - 1)];
}

function pickFirstName() {
  const count = Math.random() > .66 ? 1 : 2;
  let name = ''
  for (let i = 0; i < count; i++) {
    name += CN_REGULAR_NAME_DICT[natural(0, CN_REGULAR_NAME_DICT.length - 1)]
  }
  return name
}

function randomNameGenerator(): { firstName: string, lastName: string } {
  return {
    firstName: pickFirstName(),
    lastName: pickLastName(),
  }
}

const SPO_MERCHANT_ID = '9f93ee10-3f3f-3b95-beae-7a177d0f53e4'

function getForwardAddress(merchant_id?: string, templateIndex: number = 0) {
  const template = ADDRESS_TEMPLATES?.[templateIndex] || ADDRESS_TEMPLATES[0]
  if (merchant_id === SPO_MERCHANT_ID) {
    // for SPO, generate random name for forward address
    const name = randomNameGenerator()
    return {
      ...template,
      firstName: name.firstName,
      lastName: name.lastName,
    }
  } else {
    return {
      ...template,
      firstName: defaultFirstName,
      lastName: defaultLastName,
    }
  }
}

export {
  ADDRESS_TEMPLATES,
  getForwardAddress,
}